import { createSlice } from '@reduxjs/toolkit';
import {values} from "./FormData";

const RegFormSlice = createSlice({
    name: 'regFormInput',
    initialState: values,
    reducers: {
        formCreation: (state, action) => {
            state.push(action.payload);
        },
        pushElements: (state, action) => {
            // pushList(action.payload.credential.id, action.payload.credential.obj)
            state.fields.map(el => {
                if(el.name === action.payload.credential.id) {
                    el.props.push({
                        "value": action.payload.credential.obj,
                        "label": action.payload.credential.obj,
                        "id": action.payload.credential.obj,
                        "type": 'option'
                    })
                }
            })
        }, pushToRegistrationForm: (state, action) => {
            state.fields.map(el => {
                if(el.name === action.payload.formName) {
                    el.props.push({
                        "value": action.payload.name,
                        "label": action.payload.name,
                        "id": action.payload.id,
                        "type": 'option'
                    })
                }
            })
        },
    }
})

export const {formCreation, reloadState, pushElements, pushToRegistrationForm} = RegFormSlice.actions;
export default RegFormSlice;